import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import Container from "../Container/Container";
import "./login.scss";

const Login: React.FC = () => {
  const { loginWithRedirect } = useAuth0();

  return (
    <Container type="wide">
      <div className="login">
        <h2 className="login__heading">Sveiki atvykę į savarankiško mokymosi aplinką!</h2>
        <p className="login__secondary-text">
          Čia galite patogiai ir savo tempu mokytis pirmosios pagalbos bei higienos įgūdžių
          teorijos. Šioje erdvėje rasite visą reikiamą informaciją, mokomąją medžiagą bei užduotis,
          padėsiančias įgyti arba atnaujinti svarbias žinias.
        </p>
        <button className="login__button" onClick={() => loginWithRedirect()}>
          Prisijungti
        </button>
        <p className="login__important">
          <strong>Svarbu!</strong>
        </p>
        <div className="login__text">
          <p className="login__text">
            Išlaikius teorijos ir praktikos dalis mokymosi aplinkoje, išduodamas tik higienos
            įgūdžių akredituotas pažymėjimas.
          </p>
          <p className="login__text">
            Norint gauti pirmosios pagalbos akredituotą pažymėjimą, po teorinės dalies išlaikymo
            mokymosi platformoje pateikiama registracija į kontaktiniu būdu vykstančią praktinę
            dalį. Tik ją sėkmingai užbaigus, išduodamas pažymėjimas.
          </p>
        </div>
        <p className="login__secondary-text">
          Norėdami įsigyti mokymų programas, <strong>spauskite</strong>:
        </p>
        <div className="login__text">
          <ul className="login__list">
            <li className="login__list-item">
              Higienos įgūdžių mokymai:{" "}
              <a
                href="https://firstaid.lt/higienos-igudziu-mokymai"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://firstaid.lt/higienos-igudziu-mokymai
              </a>
            </li>
            <li className="login__list-item">
              Pirmosios pagalbos mokymai:{" "}
              <a
                href="https://firstaid.lt/privalomieji-pirmosios-pagalbos-mokymai"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://firstaid.lt/privalomieji-pirmosios-pagalbos-mokymai
              </a>
            </li>
          </ul>
        </div>

        <p className="login__secondary-text">
          Sėkmingo mokymosi ir prasmingo laiko šiame savarankiško tobulėjimo kelyje!
        </p>
      </div>
    </Container>
  );
};

export default Login;
